import {POWER_FIELDS} from './constants';

export interface PowerDelta {
  timestamp: number;
  values: Record<string, number>;
}

export const sumDeltas = (deltas: PowerDelta[]): Record<string, number> => {
  const totals: Record<string, number> = {};
  POWER_FIELDS.forEach(f => { totals[f.id] = 0; });
  deltas.forEach(d => {
    POWER_FIELDS.forEach(f => {
      totals[f.id] += d.values[f.id] ?? 0;
    });
  });
  return totals;
};

export const filterDeltasByHour = (
  deltas: PowerDelta[],
  startHour: number,
  endHour: number,
  tzHours: number,
): PowerDelta[] => {
  return deltas.filter(d => {
    const localHour = ((new Date(d.timestamp).getUTCHours() + tzHours) % 24 + 24) % 24;
    if (startHour <= endHour) {
      return localHour >= startHour && localHour < endHour;
    }
    return localHour >= startHour || localHour < endHour;
  });
};
